import { useNavigate, useParams } from 'react-router-dom';

const useLocalizedNavigate = () => {
  const navigate = useNavigate();
  const { lang } = useParams();

  return (to, options) => {
    if (typeof to === 'string' && to.startsWith('/')) {
      navigate(`/${lang}${to}`, options);
    } else {
      navigate(to, options);
    }
  };
};

export default useLocalizedNavigate;
